(function () {
  function initVideoList(root) {
    var toggles = root.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var index = toggle.getAttribute('data-accordion-toggle');
        var content = root.querySelector('[data-accordion-content="' + index + '"]');
        var isOpen = toggle.classList.contains('is-active');

        toggle.classList.toggle('is-active', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));

        if (content) {
          content.toggleAttribute('hidden', isOpen);
        }
      });
    });

    var placeholders = root.querySelectorAll('[data-placeholder-toggle]');
    placeholders.forEach(function (placeholder) {
      placeholder.addEventListener('click', function () {
        placeholder.classList.toggle('is-playing');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.video-list-99').forEach(initVideoList);
  });
})();